<template>
  <div>
    <div
      v-if="$slots['default']"
      class="loader-title"
    >
      <slot />
    </div>
    <div class="loader" />
  </div>
</template>

<script>
export default {
  name: 'MozLoader',
};
</script>

<style lang="scss" scoped>
  .loader {
    width: 41px;
    height: 41px;
    display: inline-block;
    animation: spin 4s linear infinite;
    background-size: contain;
    background-image: url('../assets/svg/loader.svg');
    @media screen and (min-width: $tablet-width) {
      width: 48px;
      height: 48px;
    }
  }
  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }

  .loader-title {
    margin-bottom: 8px;
    font-size: 16px;
    line-height: 1.75;
    color: #373f47;
  }
</style>
